// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"265":"component---src-pages-main-al-jsx","556":"component---src-campaigns-diabetamina-jsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"265":"ecac37f3a4f4893415e0","556":"5f80f5de3dbba0afdc9e","589":"d0bc1f47d108582f2fed","883":"3bae0aaeac1d66331e50"}[chunkId] + ".js";
};